import { ICountryFlagProps } from 'types/shared';

const SET_CHARTS_COUNTRIES = 'SET_CHARTS_COUNTRIES';
const SET_SELECTED_CHARTS = 'SET_SELECTED_CHARTS';

const initialState: TState = {
  countries: [],
  customerCharts: [],
};

export default reducer;

function reducer(state: TState = initialState, action: TAction): TState {
  switch (action.type) {
    case SET_CHARTS_COUNTRIES:
      return {
        ...state,
        countries: action.countries,
      };
    case SET_SELECTED_CHARTS:
      return {
        ...state,
        customerCharts: action.customerCharts,
      };
    default:
      return state;
  }
}

type TState = {
  countries: ICountryFlagProps[];
  customerCharts: any[];
};

type TAction =
  | {
      type: typeof SET_CHARTS_COUNTRIES;
      countries: ICountryFlagProps[];
      customerCharts: any[];
    }
  | {
      type: typeof SET_SELECTED_CHARTS;
      countries: ICountryFlagProps[];
      customerCharts: any[];
    };
